import React, { useState } from 'react'
import logo from '@/assets/background/logo.png'
import QRcode from '@/assets/background/qrcode.png'
import styles from './index.less'

export default () => {
  return (
    <div className={styles.footer_container}>
      <div className={styles.content}>
        <div className={styles.left}>
          <img src={logo} style={{ width: 'auto', height: '40px' }} />
          <div class="foot_center_context">
            <ul>
              <a href="https://openanolis.cn/page/about" target="_self">
                <li>关于我们</li>
              </a>
              <a href="https://openanolis.cn/page/brand" target="_self">
                <li>法律声明</li>
              </a>
              <a
                href="https://openanolis.cn/page/privacy-policy"
                target="_self"
              >
                <li>隐私政策</li>
              </a>
              <a href="https://www.yuque.com/anolis-docs" target="_self">
                <li>帮助文档</li>
              </a>
              <a href="https://openanolis.cn/page/contact" target="_self">
                <li>联系我们</li>
              </a>
              <a
                href="https://bugzilla.openanolis.cn/enter_bug.cgi?classification=Infrastructures"
                target="_self"
              >
                <li>提交建议</li>
              </a>
            </ul>
          </div>

          {/* <div>
            <span>关于我们</span>
            <span>法律声明</span>
            <span>隐私政策</span>
            <span>帮助文档</span>
            <span>联系我们</span>
            <span>提交建议</span>
          </div> */}
        </div>
        <div className={styles.right}>
          <img
            src={QRcode}
            alt="QRcode"
            style={{ width: '132px', height: '132px' }}
          />
          <p style={{ margin: 0 }}>基础设施 SIG (钉钉扫码加入)</p>
        </div>
      </div>

      <div
        style={{ height: '2px', background: '#1d222c', marginTop: '12px' }}
      ></div>

      <div className={styles.bottom}>
        <span className={styles.nobreak}>
          <a
            href="http://idinfo.zjamr.zj.gov.cn//bscx.do?method=lzxx&id=3301103301840000648381"
            target="_blank"
          >
            <img src="https://img.alicdn.com/imgextra/i4/O1CN01NWJABb1MoLIsuNI2F_!!6000000001481-1-tps-65-70.gif" />
          </a>
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002013770"
            target="_blank"
          >
            <img
              src="https://img.alicdn.com/imgextra/i2/O1CN01TRgVGF1O0zrLOD9uo_!!6000000001644-2-tps-20-20.png"
              style={{ marginRight: '10px' }}
            />
            浙公网安备 33011002016143号
          </a>
          <a href="https://beian.miit.gov.cn/" target="_blank">
            浙ICP备2021005855号-2
          </a>
        </span>
      </div>
    </div>
  )
}
